import { Component } from '@angular/core';

@Component({
  selector: 'goalmate-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'admin';
}
